import { catalogs } from "../../../texts/esp/catalogs";

export const content = {
    header:[
        {id:0,label:'',hidden:false, fixed:true, width:26, position:0, padding:'checkbox'},
        {id:1,key:'fixed_business_name',label:'Razón Social',hidden:false, width:300, fixed:true, add:{icon:'add'}, position:34},
        {id:2,key:'rfc',label:'RFC',hidden:false},
        {id:3,key:'client_classification',label:'Clasificación',hidden:false},
        {id:4,key:'client_status_id',label:'Estatus',hidden:false},
        {id:5,key:'fixed_client_responsible',label:'Asesor',hidden:false},
        //Fixed other data
        {id:6,key:'fiscal_regime',label:'Regimen Fiscal',hidden:false, add:{icon:'add'}},
        {id:7,key:'sub_activity',label:'Sub-Actividad',hidden:false},
        {id:8,key:'economic_activity_sector',label:'Actividad Económica',hidden:false},
        //{id:9,key:'',label:'Número de Seguridad Social o Registro Patronal (IMSS)',hidden:false},
        {id:9,key:'idse_user_state',label:'Estado',hidden:false},
        {id:10,key:'idse_user_city',label:'Ciudad',hidden:false},
        {id:11,key:'idse_user_user',label:'Usuario IDSE',hidden:false},
        {id:12,key:'idse_user_password',label:'Contraseña IDSE',hidden:false},
        {id:13,key:'idse_user_digital_certificate',label:'Certificado Digital IDSE',hidden:false},
        {id:14,key:'idse_user_digital_certificate_password',label:'Contraseña Certificado Digital IDSE',hidden:false},
        {id:15,key:'idse_user_sua_password',label:'Contraseña SUA',hidden:false},
        {id:16,key:'idse_user_employer_card',label:'Alta Patronal',hidden:false},
        /// New data
        {id:24,key:'presentation_limit_date',label:'Fecha Límite de Presentación',hidden:false},
        {id:25,label:'Línea de Captura',hidden:false},
        {id:26,key:'process_status_id',label:'Estatus',hidden:false},
        {id:27,key:'class_id',label:'Clase',hidden:false},
        {id:28,label:'Declaración',hidden:false},
        {id:29,label:'Respuesta Cliente',hidden:false},
        {id:30,key:'client_comment',label:'Comentario Cliente',hidden:false},
        {id:31,key:'presentation_date',label:'Fecha de Presentación',hidden:false},
        {id:32,label:'Hoja de Trabajo',hidden:false},
        {id:33,key:'extra_hours',label:'Horas Extra',hidden:false},
        {id:34,label:'Comprobante Horas',hidden:false},
        {id:35,key:'extra_charges',label:'Cargos Extra',hidden:false},
        {id:36,label:'Comprobante Cargo',hidden:false},
        {id:37,key:'collections_charge',label:'Cargo a Cobranza',hidden:false},
        {id:38,key:'delivery_date',label:'Fecha de Entrega',hidden:false},
        {id:39,key:'responsible',label:'Responsable',hidden:false},
        {id:40,key:'notes',label:'Notas',hidden:false},
        {id:41,key:'completition_date',label:'Fecha de Completado',hidden:false},
        {id:42,label:'Completado',hidden:false},

    ],
    dataConfig:[
        {id:'fixed_business_name',type:'text',fixed:true, editBtn:true, position:34},
        {id:'rfc',type:'text'},
        {id:'client_classification', type:'text'},
        {id:'client_status_id',type:'status', options: [...catalogs.client_statuses] },
        {id:'fixed_client_responsible',type:'text'},
        ///////// second fixed data
        {id:'fiscal_regime',type:'text'},
        {id:'sub_activity',type:'text'},
        {id:'economic_activity_sector',type:'text'},
        {id:'idse_user_state',type:'text'},
        {id:'idse_user_city',type:'text'},
        {id:'idse_user_user',type:'text'},
        {id:'idse_user_password',type:'text'},
        {id:'idse_user_digital_certificate',type:'text'},
        {id:'idse_user_digital_certificate_password',type:'text'},
        {id:'idse_user_sua_password',type:'text'},
        {id:'idse_user_employer_card',type:'text'},
        // Real data
        {id:'presentation_limit_date',type:'date',variant:'date',editable:true},
        {id:'capture_line',type:'document'},
        {id:'process_status_id', type:'status', options: [...catalogs.ctrl_process_statuses], editable:true},
        {id:'class_id', formId:'class_id', type:'text', editable:true},
        {id:'declaration',type:'document'},
        {id:'client_response',type:'document'},
        {id:'client_comment',type:'text',editable:true},
        {id:'presentation_date',type:'date',variant:'date',editable:true},
        {id:'worksheet',type:'document'},

        {id:'extra_hours',type:'text',editable:true},
        {id:'hours_proof',type:'document'},
        {id:'extra_charges',type:'cash',editable:true},
        {id:'charge_proof',type:'document'},
        {id:'collections_charge',type:'cash',editable:true},
        {id:'delivery_date',type:'date',variant:'date',editable:true},
        {id:'responsible',formId:'responsible_id', type:'text', editable:true},
        {id:'notes',type:'text',editable:true},
        {id:'completition_date',type:'date', variant:'date',editable:true},
        {id:'completed',type:'checkbox',editable:true},
    ]
}